module.exports = __webpack_public_path__ + "static/media/register.42f4d825.png";